import { render, staticRenderFns } from "./InsightParameters.vue?vue&type=template&id=0201d19d&scoped=true&"
import script from "./InsightParameters.vue?vue&type=script&lang=ts&"
export * from "./InsightParameters.vue?vue&type=script&lang=ts&"
import style0 from "./InsightParameters.vue?vue&type=style&index=0&id=0201d19d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0201d19d",
  null
  
)

export default component.exports